export class ReservationLogEvent {
}
//# sourceMappingURL=reservation-log-event.js.map